import {
  CreatedExternalAuthorization,
  CreateExternalAuthorization,
  CreateExternalNonce,
  CreatedExternalNonce,
  ExternalAuthorizationId,
} from "../Types";
import {CURRENT_REGION} from "../utils/region";
import jsonApi from "./jsonApi";

export async function create(req: CreateExternalAuthorization) {
  return await jsonApi.post<CreatedExternalAuthorization>(`/region/${CURRENT_REGION}/api/external_authorizations`, req);
}

export async function createNonce(externalAuthId: ExternalAuthorizationId, req: CreateExternalNonce) {
  return await jsonApi.post<CreatedExternalNonce>(
    `/region/${CURRENT_REGION}/api/external_authorizations/${externalAuthId}/nonce`,
    req,
  );
}
